<template>
  <div>
    <!--    <img src="./print.svg" alt="" style="width: 100%;">-->
    <section style="margin-top: 30px;">
      <el-card
        class="leftCard"
        shadow="never"
        style="background-color: #FBFBFB; border-color: transparent"
      >
        <div class="servInfo" v-loading="loading">
          <el-row :gutter="30" style="margin-bottom: 50px;">
            <h5 style="margin-bottom: 30px;padding-left: 15px;">基本信息</h5>
            <el-col :span="24" v-if="enterPrise.registeredCapital">
              <div class="essentialInformation">
                <span class="name">注册资本</span>
                <span class="content">{{ enterPrise.registeredCapital }}</span>
              </div>
            </el-col>
            <el-col :span="24" v-if="enterPrise.registeredDate">
              <div class="essentialInformation">
                <span class="name">成立日期</span>
                <span class="content">{{ replaceTime(enterPrise.registeredDate) }}</span>
              </div>
            </el-col>
            <el-col :span="24" v-if="enterPrise.factoryArea">
              <div class="essentialInformation">
                <span class="name">厂房面积</span>
                <span class="content">{{ enterPrise.factoryArea }}㎡</span>
              </div>
            </el-col>
            <el-col :span="24" v-if="enterPrise.productivity">
              <div class="essentialInformation">
                <span class="name">总&nbsp;&nbsp;产&nbsp;&nbsp;能</span>
                <span class="content">{{ enterPrise.productivity }}吨</span>
              </div>
            </el-col>
            <el-col :span="24" v-if="enterPrise.grossProduct">
              <div class="essentialInformation">
                <span class="name">总&nbsp;&nbsp;产&nbsp;&nbsp;量</span>
                <span class="content">{{ enterPrise.grossProduct }}吨</span>
              </div>
            </el-col>
            <el-col :span="24" v-if="enterPrise.annualVolume">
              <div class="essentialInformation">
                <span class="name">年营业额</span>
                <span class="content">{{ enterPrise.annualVolume }}万元</span>
              </div>
            </el-col>
            <el-col :span="24" v-if="enterPrise.businessScope">
              <div class="essentialInformation">
                <span class="name">经营范围</span>
                <span class="content">{{ enterPrise.businessScope }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col>
              <h5 style="margin-bottom: 30px;">企业介绍</h5>
              <div style="margin-bottom: 50px; " class="compInfo">
                <!-- <p v-html="enterPrise.content"/> -->
                <p>
                  <el-image
                    style="width: 501.11px; height: 250px; margin-left: 32px; border-radius: 8px;float:right"
                    :src="enterPrise.picture"
                    fit="fill"
                  ></el-image>
                  <span ref="contentBox">{{contentp}}</span>
                </p>
              </div>
            </el-col>
            <!-- <el-col :span="14">
                            <el-image
                                style="width: 100%; height: 250px; margin-top: 30px; border-radius: 8px;"
                                :src="enterPrise.picture"
                                fit="fill">
                            </el-image>
            </el-col>-->
          </el-row>
          <el-row :gutter="30">
            <el-col :span="10">
              <h5 style="margin-bottom: 30px;">联系我们</h5>
              <div>
                <ul class="mpDetail">
                  <li>
                    <div class="name">地址：</div>
                    <div
                      class="content"
                      id="addressMap"
                    >{{ enterPrise.province }}{{ enterPrise.city }}{{ enterPrise.district }}{{ enterPrise.address }}</div>
                  </li>
                  <li>
                    <div class="name">手机：</div>
                    <div class="content">{{ enterPrise.tel }}</div>
                  </li>
                  <li>
                    <div class="name">邮箱：</div>
                    <div class="content">{{ enterPrise.email }}</div>
                  </li>
                  <li>
                    <div class="name">网址：</div>
                    <div class="content">{{ enterPrise.webSite }}</div>
                  </li>
                </ul>
              </div>
            </el-col>
<!--            <el-col :span="14">-->
<!--              <div class="BDMap">-->
<!--                <div id="containerMap"></div>-->
<!--              </div>-->
<!--            </el-col>-->
          </el-row>
          <!-- 商家资质 -->
          <el-row :gutter="30">
            <h5 style="margin-bottom: 30px;padding-left: 15px;">商家资质</h5>
            <el-col :span="24">
              <div class="essentialInformation">
                <span class="name">企业注册号</span>
                <span class="content">{{ credential.creditCode }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="essentialInformation">
                <span class="name">企业名称</span>
                <span class="content">{{ credential.name }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="essentialInformation">
                <span class="name">类型</span>
                <span class="content">{{ credential.identityCn }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="essentialInformation">
                <span class="name">住所</span>
                <span class="content">{{ credential.parkName }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="essentialInformation">
                <span class="name">法定代表人</span>
                <span class="content">{{ credential.corporation }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="essentialInformation">
                <span class="name">营业期限</span>
                <span class="content">{{ credential.businessTerm }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="essentialInformation">
                <span class="name">经营范围</span>
                <span class="content">{{ credential.businessScope }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </section>
  </div>
</template>

<script>
import {
  getInfoByEnterPriseUuid,
  getQualifications
} from "../../utils/interface";
const credential = () => {
  return {
    creditCode: "", // 企业注册号
    name: " ", // 企业名称
    identityCn: "", // 类型
    parkName: "", // 住所
    corporation: "", //法定代表人
    businessTerm: "", // 经营期限
    businessScope: "" // 经营范围
  };
};
export default {
  //   联系我们
  name: "printContact",
  components: {},
  data() {
    return {
      url: require("../../assets/公司图片.jpeg"),
      urlmap: require("../../assets/urlmap.png"),
      uuid: "",
      enterPrise: "",
      point: "",
      mapAddress: "",
      center: "宁夏",
      contentp: "",
      map: null,
      // BMap:null,
      loading: true,
      credential: credential()
    };
  },
  created() {
    console.log("enterPriseId", this.$route.params.enterPriseId);
    this.uuid = this.$route.params.enterPriseId;
  },
  mounted() {
    this.getInfoByEnterPriseUuid();
    this.getQualifications();
  },
  methods: {
    replaceTime(time) {
      if (time.length > 11) {
        return time.substring(0, 11);
      } else {
        return time;
      }
    },
    initMap(address) {
      address = this.mapAddress
        .replaceAll(/、/g, "")
        .replaceAll(" ", "")
        .replaceAll(/,/g, "");
      // let map = (this.map = new BMapGL.Map("containerMap")); // 创建地图实例
      // var point = new BMapGL.Point(116.404, 39.915); // 创建点坐标
      // map.centerAndZoom(point, 15); // 生成地图
      //
      // let localSearch = new BMapGL.LocalSearch(map);
      // localSearch.setSearchCompleteCallback(result => {
      //   let point = result.getPoi(0);
      //   map.centerAndZoom(point.point, 15);
      //   let marker = new BMapGL.Marker(
      //     new BMapGL.Point(point.point.lng, point.point.lat)
      //   ); // 创建标注，为要查询的地址对应的经纬度
      //   map.addOverlay(marker);
      // });
      // localSearch.search(address);
    },
    getInfoByEnterPriseUuid() {
      getInfoByEnterPriseUuid({ enterPriseUuid: this.uuid }).then(res => {
        // console.log(res)
        this.enterPrise = res.data.enterPriseInfo;
        this.contentp = this.enterPrise.content;
        this.$refs.contentBox.innerHTML = this.contentp;
        // this.contentp=this.enterPrise.content.replace(/<.*?>/ig,"")
        // this.contentp=this.enterPrise.content.replace(/<[^>]+>/g, "")
        this.mapAddress =
          this.enterPrise.province +
          this.enterPrise.city +
          this.enterPrise.district +
          this.enterPrise.address;
        this.loading = false;
        //this.initMap(this.mapAddress.replaceAll(/、/g,"").replaceAll(" ","").replaceAll(/,/g,""));
      });
    },
    // 获取商家资质
    getQualifications() {
      getQualifications(this.uuid).then(res => {
        if (Object.keys(res).length > 0) {
          for (let key in this.credential) {
            this.credential[key] = res[key];
          }
        } else {
          this.credential = credential();
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.containerbox {
  width: 1200px;
  margin: 0 auto;
}

.leftCont {
  margin-top: 30px;

  .leftCard {
    margin-bottom: 30px;
    border: none;

    /deep/ .el-card__header {
      color: #157efb;
      background-color: #f3f3f3;
      font-size: 18px;
      padding: 12px 20px;
    }

    /deep/ .el-card__body {
      background-color: #fbfbfb;
    }
  }

  .servInfo h3 {
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 15px;
  }

  .servInfo .eval li {
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
  }

  .servInfo .eval li span {
    margin-right: 30px;
  }

  .servInfo .contact {
    margin-top: 30px;
    margin-bottom: -10px;
    font-size: 12px;
  }

  .servInfo .contact i {
    margin-right: 5px;
  }

  .servInfo .contact p {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.printTitle {
  font-size: 16px;
  font-weight: normal;
  color: #157efb;
  margin-top: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;

  span.tit {
    padding-bottom: 10px;
    border-bottom: 1px solid #157efb;
  }

  span.more {
    font-size: 16px;
    float: right;
    margin-top: 10px;
  }

  .more i {
    color: #505050 !important;
  }
}

.hotSell {
  margin-bottom: -30px;

  li {
    margin-bottom: 30px;
  }

  .topServBoxInfo h3 {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: normal;
  }

  .topServBoxInfo p {
    font-size: 12px;
    color: #aaa;
  }
}

.relateServ {
  margin-bottom: -30px;

  li {
    margin-bottom: 30px;
  }

  .topServBoxInfo h3 {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: normal;
  }
}

.topServBox {
  background-color: #fff;
  height: 200px;
  border-radius: 8px;
  box-shadow: 0 1px 5px #eaeaea;
  margin-top: -100px;
  padding: 30px;
  box-sizing: border-box;

  .topServBoxInfo h3 {
    font-size: 16px;
    margin-bottom: 6px;
    font-weight: normal;
  }

  .topServBoxInfo p {
    font-size: 12px;
    color: #585858;
  }

  /deep/ .el-menu.el-menu--horizontal {
    border-color: transparent;
  }

  /deep/ .el-menu--horizontal > .el-menu-item.is-active {
    border: none !important;
    background-color: #f3f8ff;
    border-radius: 5px;
  }

  /deep/ .el-menu--horizontal > .el-menu-item {
    height: 30px;
    line-height: 26px;
  }
}

.topServBoxNum {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  p:first-child {
    font-size: 16px;
  }

  p:last-child {
    font-size: 12px;
    color: #585858;
  }
}

.menu-sub {
  margin-top: 35px;
  font-size: 16px;
}

.box-card {
  margin-bottom: 30px;
  position: relative;

  .image {
    width: 100%;
    height: 200px;
    display: block;
  }
}

.compInfo p {
  text-indent: 2em;
  font-size: 14px;
  line-height: 2;
  letter-spacing: 0px;
  color: #808080;
  text-align: justify;
}

.mpBox {
  display: flex;
  align-items: center;
}

.mpCheck {
  position: absolute;
  right: 20px;
  top: 20px;
}

.mpTitle {
  font-size: 16px;
  font-weight: normal;
}

.mpComp {
  margin-top: 10px;
  font-size: 13px;
  color: #000000;
}

.mpPrice {
  margin: 10px 0;
  font-size: 13px;
  color: #da251d;

  span {
    color: #000;
    margin-left: 10px;
  }
}

.mpDetail {
  margin-top: 10px;
  li {
    display: flex;
    .name {
      min-width: 70px;
      width: 70px;
      color: #000;
      font-size: 13px;
      font-weight: normal;
      line-height: 22px !important;
    }
    .content {
      font-size: 10px;
      line-height: 22px !important;
      margin-left: 15px;
      margin-bottom: 15px;
      color: #808080;
      word-break: break-all;
      word-wrap: break-word;
    }
  }
}

.mpFooter-v1 {
  text-align: center;
  font-size: 14px;
  background: #f1f5fe;
  border: 1px solid #ebeef5;
  margin: -10px -21px -21px;
  height: 50px;
  line-height: 50px;
}

.mpFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-top: 1px solid #e3e3e3;
  margin: 0 0 -15px;
  position: relative;

  span {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 13px;
    height: 50px;
    line-height: 50px;
  }

  span a {
    font-size: 12px;
    color: #808080;
  }

  span a:hover {
    color: rgba(21, 126, 251, 0.8);
  }

  :after {
    position: absolute;
    content: "";
    width: 1px;
    background-color: #e3e3e3;
    height: 34px;
    top: 8px;
    left: 50%;
  }
}

.printBox {
  /deep/ .el-input--suffix .el-input__inner {
    padding: 0 15px;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

a {
  color: #157efb;
}

a:hover {
  color: rgba(21, 126, 251, 0.8);
}

.mpTime {
  font-size: 12px;
  color: #aaa;
  margin-top: 6px;
}
.essentialInformation {
  color: #000;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  padding-bottom: 15px;
  display: flex;
  span {
    display: inline-block;
    &.name {
      min-width: 80px;
    }
    &.content {
      color: #808080;
    }
  }
}
.BDMap {
  width: 483px;
  height: 200px;
  margin-top: 30px;
  border-radius: 8px;
  #containerMap {
    width: 483px;
    height: 200px;
    margin-top: 30px;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/print/printContact.vue